function IndustriesSlider() {
  const sliders = document.querySelectorAll(".industries .splide");

  if (!sliders.length) return;

  sliders.forEach(el => {
    // Prevent double initialization
    if (el.dataset.splideInitialized === "true") return;

    const options = {
      type: "slide",
      autoWidth: false,
      perPage: 1,
      perMove: 1,
      gap: 16,
      mediaQuery: "min",
      pagination: false,
      speed: 500,
      keyboard: true,
      breakpoints: {
        576: {
          perPage: 2,
          perMove: 1
        },
        768: {
          perPage: 3,
          perMove: 1
        },
        992: {
          perPage: 4,
          perMove: 1
        }
      }
    };

    try {
      new Splide(el, options).mount();
      el.dataset.splideInitialized = "true";
    } catch (e) {
      // Fail gracefully without breaking the rest of the page
      console.error("[industries] Failed to initialize Splide:", e);
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  IndustriesSlider();
});
